/**
 * Nguồn dữ liệu tùy chỉnh báo cáo
 * pqkhanh 09.08.2024
 */
export default {
  Estimate: 2, // Dự toán
  Explanation: 1, // Thuyết minh
};
